import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import { useCompetitionStore } from '../../stores/competitionStore';
import { useErrorStore } from '../../stores/errorStore';
import dialogStrings from '../../strings/definitions/dialogStrings';
import { ICompetitionSettings } from '@cyber-range/cyber-range-api-ctf-competition-client';
import Route from '../route';

export default async function requireCybersafeCompetition(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): Promise<void>
{
    const competition = useCompetitionStore().currentCompetition;
    const settings = competition?.settings as ICompetitionSettings;

    if (!settings?.requirePlayerRandomChallengeListing)
    {
        useErrorStore().setError({
            statusCode: 404,
            message: dialogStrings.en.ERROR_COMPETITION_NOT_FOUND,
            details: ''
        });
        return next({ name: Route.Splash.name });
    }

    return next();
}
